<template>
    <div>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item>
                    <i class='el-icon-lx-cascades'></i> 污水罐预警
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class='container'>
            <div class='handle-box'>

                <el-select filterable v-model='enterpriseSearchId' placeholder='企业' style='width: 140px;margin-right: 20px'>
                    <el-option
                        v-for='item in enterpiseOptionsSearch'
                        :key='item.value'
                        :label='item.label'
                        :value='item.value'>
                    </el-option>
                </el-select>


                <el-button type='primary' icon='el-icon-search' @click='handleSearch'>查询</el-button>
<!--                <el-button type='primary' icon='el-icon-plus' @click='addVisible=true'>添加</el-button>-->


            </div>
            <el-table
                :data='tableData'
                border
                class='table'
                ref='multipleTable'
                header-cell-class-name='table-header'
            >
                <el-table-column label='序号' align='center' :index='indexMethod' type='index' width='40'>
                </el-table-column>
                <el-table-column label='企业名称' align='center'>
                    <template slot-scope='scope'>{{ scope.row.enterpriseName }}</template>
                </el-table-column>
                <el-table-column label='污水罐编号' align='center'>
                    <template slot-scope='scope'>{{ scope.row.deviceN }}</template>
                </el-table-column>
                <el-table-column label='污水罐容量(L)' align='center'>
                    <template slot-scope='scope'>{{ scope.row.capacity }}</template>
                </el-table-column>

                <el-table-column label='污水罐高度(M)' align='center'>
                    <template slot-scope='scope'>{{ scope.row.height }}</template>
                </el-table-column>

                <el-table-column label='设备ID' align='center'>
                    <template slot-scope='scope'>{{ scope.row.deviceId }}</template>
                </el-table-column>
                <el-table-column label='预警状态' align='center'>
                    <template slot-scope='scope'>{{ scope.row.statusName }}</template>
                </el-table-column>
                <el-table-column label='当前水位(M)' align='center'>
                    <template slot-scope='scope'>{{ scope.row.currentHeight }}</template>
                </el-table-column>
                <el-table-column label='预警时间' align='center'>
                    <template slot-scope='scope'>{{ scope.row.alarmTime }}</template>
                </el-table-column>
<!--                <el-table-column label='操作' width='180' align='center'>-->
<!--                    <template slot-scope='scope'>-->
<!--                        <el-button-->
<!--                            type='text'-->
<!--                            icon='el-icon-edit'-->
<!--                            @click='handleEdit(scope.$index, scope.row)'-->
<!--                        >编辑查看-->
<!--                        </el-button>-->
<!--                        <el-button-->
<!--                            type='text'-->
<!--                            icon='el-icon-delete'-->
<!--                            class='red'-->
<!--                            @click='handleDelete(scope.$index, scope.row)'-->
<!--                        >删除-->
<!--                        </el-button>-->
<!--                    </template>-->
<!--                </el-table-column>-->

            </el-table>
            <div class='pagination'>
                <el-pagination
                    background
                    layout='total, prev, pager, next'
                    :current-page='query.pageIndex'
                    :page-size='query.pageSize'
                    :total='pageTotal'
                    @current-change='handlePageChange'
                ></el-pagination>
            </div>
        </div>
        <el-dialog title='编辑污水罐' :visible.sync='editVisible' width='40%'>
            <el-form ref='form' :model='form' label-width='120px'>

                <el-form-item label='企业名称'>
                    <el-select v-model='form.enterpriseId' placeholder='企业' style='width: 140px;margin-right: 20px'>
                        <el-option
                            v-for='item in enterpiseOptionsSearch'
                            :key='item.value'
                            :label='item.label'
                            :value='item.value'>
                        </el-option>
                    </el-select>

                </el-form-item>
                <el-form-item label='污水罐编号'>
                    <el-input v-model='form.deviceN' maxlength='11'></el-input>
                </el-form-item>
                <el-form-item label='污水罐容量(L)'>
                    <el-input v-model='form.capacity' maxlength='11'></el-input>
                </el-form-item>
                <el-form-item label='污水罐高度(M)'>
                    <el-input v-model='form.height' ></el-input>
                </el-form-item>
                <el-form-item label='设备ID'>
                    <el-input v-model='form.deviceId' ></el-input>
                </el-form-item>
                <el-form-item label='当前水位(M)'>
                    <el-input v-model='form.currentHeight'  disabled></el-input>
                </el-form-item>


            </el-form>

            <span slot='footer' class='dialog-footer'>
                <el-button @click='editVisible = false'>取 消</el-button>
                <el-button type='primary' @click='editHttp'>确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title='添加污水罐' :visible.sync='addVisible' width='40%'>


            <el-form ref='form' :model='form' label-width='120px'>

                <el-form-item label='企业名称'>
                    <el-select v-model='createForm.enterpriseId' placeholder='企业' style='width: 140px;margin-right: 20px'>
                        <el-option
                            v-for='item in enterpiseOptionsSearch'
                            :key='item.value'
                            :label='item.label'
                            :value='item.value'>
                        </el-option>
                    </el-select>

                </el-form-item>
                <el-form-item label='污水罐编号'>
                    <el-input v-model='createForm.deviceN' maxlength='11'></el-input>
                </el-form-item>
                <el-form-item label='污水罐容量(M)'>
                    <el-input v-model='createForm.capacity' maxlength='11'></el-input>
                </el-form-item>
                <el-form-item label='污水罐高度(L)'>
                    <el-input v-model='createForm.height' ></el-input>
                </el-form-item>
                <el-form-item label='设备ID'>
                    <el-input v-model='createForm.deviceId' ></el-input>
                </el-form-item>

            </el-form>
            <span slot='footer' class='dialog-footer'>
                <el-button @click='addVisible = false'>取 消</el-button>
                <el-button type='primary' @click='addUserHttp' :loading="submitLoading" :disabled='submitLoading'>确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
import { countDown, formatDate, formatDates } from '@/utils/formatDate';
import { baseUrl } from '@/utils/nHttp';

export default {
    name: 'basetable',
    data() {
        return {
            submitLoading:false,
            enterpriseSearchId:"",
            enterpiseOptionsSearch:[],
            query: {
                name: '',
                pageIndex: 1,
                pageSize: 10,
                type:''
            },
            queryService: {
                name: '',
                pageIndex: 1,
                pageSize: 10000
            },
            memberVisible:false,
            tableData: [],
            multipleSelection: [],
            delList: [],
            cardPwdType: '0',
            editVisible: false,
            addVisible: false
            ,
            createForm: {}
            ,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1,
            options: [],
            value: [],
            editValue: [],
            provinceOptions: [],
            cityOptions: [],
            provinceValue: '',
            cityValue:"",
            areaOptions:[],
            areaValue:"",
            editCurrentProgress: '1',
            editCurrentProgressName: '',
            serviceProviderOptions: [],
            serviceProviderValue: [],
            lastEnterpriseOptions: [],
            lastEnterpriseValue: '',
            memberStartTimeStr:"",
            memberEndTimeStr:"",
            types:[
                { 'value': "", 'label': "请选择在线状态" },
                { 'value': "1", 'label': "在线" },
                { 'value': "0", 'label': "不在线" }
            ]


        };
    },
    created() {
        this.getData();
        this.getEnterpiseSearch();
        // this.getCity();

    },

    watch: {

        //监听内容
        provinceValue() {
            let that = this;
            this.areaValue=''
            this.cityValue=''
            let param = {"id":this.provinceValue}
            this.http.get('user/getCity', param).then(res => {
                    if (res.code == 0) {
                        that.cityOptions = [{"id":"","name":"请选择市"},...res.data] ;
                        // that.pageTotal = parseInt(res.data.total);
                        // this.$message.success('获取数据成功');
                    }
                },
                err => {

                });

            console.log("provinceValue"+this.provinceValue)
        },
        cityValue(){
            let that = this;
            let param = {"id":this.cityValue}
            this.areaValue=''
            this.http.get('user/getAreaById', param).then(res => {
                    if (res.code == 0) {
                        that.areaOptions =[{"id":"","name":"请选择区"},...res.data] ;
                        // that.pageTotal = parseInt(res.data.total);
                        // this.$message.success('获取数据成功');
                    }
                },
                err => {

                });
        },
        areaValue(){
            let that = this;

        }
    },
    methods: {

        getEnterpiseSearch() {
            let that = this;
            let param = {}
            this.http.getToken('/qwpenterprise/getListOption', param).then(res => {
                    if (res.code == 0) {
                        that.enterpiseOptionsSearch.push({ 'value': '', 'label': '请选择企业' });
                        res.data.forEach(res => {
                            that.enterpiseOptionsSearch.push({ 'value': res.id, 'label': res.name });
                        });

                    }
                },
                err => {

                });
        },





        //禁用
        handleForbidden(index, row) {
            // 二次确认删除
            console.log(index);
            console.log(row.uid);
            let that = this;
            let params = {};
            let msg = '';

                msg = '确定要审批通过吗？' ;
                params = { 'id': row.id, 'status': 1 };

//0不可用1可用
            this.$confirm(msg, '提示', {
                type: 'warning'
            })
                .then(() => {
                    that.http.post('qwpenterprise/updateStatus', params).then(res => {
                        if (res.code == 0) {
                            that.getData();
                            this.$message.success('操作成功');
                        }
                    });

                })
                .catch(() => {
                });
        },
        indexMethod(index) {
            return index + 1;
        },
        getCity() {

        },
        // 触发搜索按钮
        handleSearch() {
            this.query.pageIndex = 1;
            this.query.provinceId = this.provinceValue;
            this.query.cityId = this.cityValue;

            this.getData();

        }
        ,
        getData() {
            let that = this;
            console.log(this.query.pageSize);
            this.query.provinceId=this.provinceValue
            this.query.cityId=this.cityValue
            this.query.areaId=this.areaValue
            this.http.getToken('/SewageTank/getListAlarm', this.query).then(res => {
                    if (res.code == 0) {
                        that.tableData = res.data.records;
                        that.pageTotal = parseInt(res.data.total);
                        this.$message.success('获取数据成功');
                    }
                },
                err => {

                });
        },
        delUserHttp(id) {
            let that = this;
            this.http.postToken('/SewageTank/delById', { 'id': id }).then(res => {
                    if (res.code == 0) {
                        that.getData();
                        that.$message.success('删除成功');
                    }
                },
                err => {

                });
        }
        ,
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            let that = this;
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    that.delUserHttp(row.id);

                })
                .catch(() => {
                });
        },

        addUser() {
            this.addVisible = true;
            this.createForm = {};

        },

        addUserHttp() {
            let that = this;
            this.submitLoading = true;
            this.http.postToken('SewageTank/add', this.createForm).then(res => {
                if (res.code === 0) {
                    that.getData();
                    that.addVisible = false;
                    this.$message.success('添加成功');
                }
                // 设置一个1000毫秒后执行的定时任务
                setTimeout(function() {
                    that.submitLoading=false;
                }, 1000);

            });
        }

,
        editHttp() {
            console.log(this.form)

            let that = this;

            // this.form.provinceId = this.form.value[0];
            // this.form.cityId = this.form.value[1];
            // this.form.cardPwdType = this.cardPwdType;


            this.http.postToken('SewageTank/editById', this.form).then(res => {
                if (res.code == 0) {
                    that.getData();
                    that.editVisible = false;
                    that.$message.success('编辑成功');
                }
            });
        }
        ,
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;

            this.form = JSON.parse(JSON.stringify(row));
            this.form.enterpriseId= this.form.enterpriseId+""

            this.editVisible = true;
        },
        // 保存编辑
        saveEdit() {
            this.editVisible = false;
            this.$message.success(`修改第 ${this.idx + 1} 行成功`);
            this.$set(this.tableData, this.idx, this.form);
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>

.avatar-uploader .el-upload {
    border-radius: 6px;
    width: 80px;
    height: 80px;
    text-align: center;

}

.avatar-uploader {
    border-color: #409EFF;
    text-align: center;
    margin-bottom: 40px;
    text-align: center;

}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
    text-align: center;
}

.avatar {
    width: 80px;
    height: 80px;
    display: block;
    margin: auto auto;
    text-align: center;
}

.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
